import { RESOURCES } from './resources';

const resources = Object.values(RESOURCES);

export const DASHBOARD_SALES_RESOURCES = resources.filter((resource) => resource.startsWith('DASHBOARD_VENDAS_'));
export const DASHBOARD_FINANCE_RESOURCES = resources.filter(
  (resource) =>
    resource.startsWith('DASHBOARD_FINANCEIRO_') &&
    resource !== RESOURCES.DASHBOARD_FINANCEIRO_GRAFICO_METODOS_DE_PAGAMENTO,
);
export const DASHBOARD_OPERATION_RESOURCES = resources.filter((resource) =>
  resource.startsWith('DASHBOARD_OPERACIONAL_'),
);
export const DASHBOARD_RESOURCES = [
  ...DASHBOARD_SALES_RESOURCES,
  ...DASHBOARD_FINANCE_RESOURCES,
  ...DASHBOARD_OPERATION_RESOURCES,
  RESOURCES.SUPRIMENTOS_ORDEMS_DE_COMPRA,
];

export const PICKLIST_RESOURCES = [
  RESOURCES.SUPRIMENTOS_PICKING,
  RESOURCES.SUPRIMENTOS_SEPARACAO,
  RESOURCES.SUPRIMENTOS_ABASTECIMENTO,
  RESOURCES.SUPRIMENTOS_ABASTECIMENTO_COMBINADO,
];

export const WAREHOUSE_TASK_RESOURCES = [
  RESOURCES.SUPRIMENTOS_SEPARACAO,
  RESOURCES.SUPRIMENTOS_ABASTECIMENTO,
  RESOURCES.SUPRIMENTOS_ABASTECIMENTO_COMBINADO,
];

export const PURCHASE_INVOICE_READ_RESOURCES = [
  RESOURCES.SUPRIMENTOS_NOTAS_FISCAIS_DE_ENTRADA,
  RESOURCES.SUPRIMENTOS_RECEBIMENTO_MERCADORIAS,
];
